import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Estimation from './pages/Estimation';
import Booking from './pages/Booking';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

// Create helmet context
const helmetContext = {};

function App() {
  return (
    <HelmetProvider context={helmetContext}>
      <Router>
        <div className="App">
          <TopBar />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/estimation" element={<Estimation />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;